import { useEffect, useState, useRef } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Send } from "lucide-react";

export default function ChatPage({ role }) {
  // role: "client" | "dietitian"
  const [msgs, setMsgs] = useState([]);
  const [t, setT] = useState("");
  const scrollRef = useRef();
  const endpoint = role === "client" ? "/app/client/messages" : null;

  const load = () => {
    if (!endpoint) return;
    api.get(endpoint).then((r) => setMsgs(r.data)).catch(() => {});
  };
  useEffect(() => {
    load();
    const int = setInterval(load, 8000);
    return () => clearInterval(int);
  }, []);

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [msgs]);

  const send = async (e) => {
    e.preventDefault();
    if (!t.trim()) return;
    try {
      await api.post(endpoint, { text: t });
      setT(""); load();
    } catch (e) { toast.error(formatApiError(e?.response?.data?.detail)); }
  };

  return (
    <div className="flex flex-col" style={{ minHeight: "calc(100vh - 200px)" }}>
      <div className="section-eyebrow">Chat</div>
      <h1 className="mt-1 font-display text-3xl leading-tight" style={{ color: "var(--primary)" }}>Your dietitian</h1>

      <div ref={scrollRef} className="mt-6 flex-1 overflow-y-auto space-y-2" style={{ maxHeight: "60vh" }}>
        {msgs.length === 0 && <div className="text-center text-sm py-8" style={{ color: "var(--text-secondary)" }}>Say hi to your dietitian 👋</div>}
        {msgs.map((m) => {
          const mine = m.from_role === role;
          return (
            <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
              <div className="max-w-[75%] px-3 py-2 rounded-2xl text-sm" style={{
                background: mine ? "var(--primary)" : "var(--bg)",
                color: mine ? "var(--yellow)" : "var(--primary)",
                border: mine ? "none" : "1px solid var(--border-subtle)",
              }}>
                {m.text}
                <div className="text-[9px] mt-1 opacity-60">{new Date(m.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</div>
              </div>
            </div>
          );
        })}
      </div>

      <form onSubmit={send} className="mt-4 flex gap-2 sticky bottom-20">
        <input data-testid="chat-input" value={t} onChange={(e) => setT(e.target.value)} placeholder="Type a message…" className="flex-1 h-12 rounded-full px-4 border-2 bg-white text-sm" style={{ borderColor: "var(--border-strong)" }} />
        <button data-testid="chat-send" className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: "var(--primary)", color: "var(--yellow)" }}><Send size={18} /></button>
      </form>
    </div>
  );
}
